import React from "react";
import PhotoDetail from "../../components/faceswap/Photo/photo-detail";

export default function PhotoDetails() {
  return <PhotoDetail />;
}
